import { render, staticRenderFns } from "./AddWrestler.vue?vue&type=template&id=9c0a3da8&scoped=true"
import script from "./AddWrestler.vue?vue&type=script&lang=js"
export * from "./AddWrestler.vue?vue&type=script&lang=js"
import style0 from "./AddWrestler.vue?vue&type=style&index=0&id=9c0a3da8&prod&scoped=true&lang=css"
import style1 from "./AddWrestler.vue?vue&type=style&index=1&id=9c0a3da8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c0a3da8",
  null
  
)

export default component.exports